export default __webpack_public_path__ + "static/media/2.25f60f1e.png";